import React, { useState, useEffect } from 'react';

import { Checkbox, MenuItem } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CustomMenu, { DropdownList } from 'components/CustomMenu';
import styled from 'styled-components';
import { StyledTooltip, StyledTypography } from 'styles/common';

import { truncateString } from 'constants/helper';
import { withStyledIcon } from 'constants/icons';

import { getEmployeesInfo } from 'services/admin';

import { StyledFilterDisplay, ScrollableContainer, LastMenuItem, LoadMoreItem } from '../styles';

const StyledExpandMoreIcon = withStyledIcon(ExpandMoreIcon);

const MAX_LENGTH_EMPLOYEE_NAME = 17;

const EmployeeFilter = ({ selectedFilters, updateFilters, filterName, noLeftBorder = false, icon }) => {
  const [loading, setLoading] = useState(null);
  const [selected, setSelected] = useState({});
  const [employees, setEmployees] = useState([]);

  // Pagination
  const [page, setPage] = useState(0);
  const [isShowLoadMore, setIsShowLoadMore] = useState(true);
  const limit = 100;

  const getEmployees = () => {
    setLoading(true);
    getEmployeesInfo({ searchText: '', offset: page * limit, limit: 100 })
      .then((res) => {
        setEmployees([...employees, ...res.map((e) => ({ value: `'${e.email}'`, label: e.displayName }))]);
        if (res.length < limit) {
          setIsShowLoadMore(false);
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => setLoading(false));
  };

  useEffect(getEmployees, [page]);

  const onLoadMore = () => {
    setPage(page + 1);
  };

  const makeCurrentStateEqualToSelectedState = () => {
    const selected = {};
    selectedFilters.forEach((id) => (selected[id] = true));
    setSelected(selected);
  };

  const handleSelect = (value) => {
    setSelected((selected) => ({ ...selected, [value]: !selected[value] }));
  };

  const handleApplyClick = () => {
    updateFilters(
      Object.keys(selected).filter((id) => selected[id]),
      filterName
    );
    document.body.click();
  };

  const removeFilters = (e) => {
    e.stopPropagation();
    updateFilters([], filterName);
  };

  return (
    <CustomMenu
      icon={
        <StyledFilterDisplay
          width="20%"
          icon={icon}
          name={filterName}
          selectedCount={selectedFilters.length}
          noLeftBorder={noLeftBorder}
          active={selectedFilters.length > 0}
          disabled={loading}
          removeFilters={removeFilters}
        />
      }
      onOpen={makeCurrentStateEqualToSelectedState}
    >
      <StyledDropdownList>
        <ScrollableContainer>
          {employees &&
            employees.map((employee, index) => (
              <MenuItem onClick={() => handleSelect(employee.value)} value={employee.value}>
                <Checkbox checked={Boolean(selected[employee.value])} color="primary" />
                <StyledTooltip title={employee.label?.length > MAX_LENGTH_EMPLOYEE_NAME ? employee.label : ''}>
                  <StyledTypography display="inline" variant="body2">
                    {truncateString(employee.label, MAX_LENGTH_EMPLOYEE_NAME)}
                  </StyledTypography>
                </StyledTooltip>
              </MenuItem>
            ))}
          {isShowLoadMore && (
            <LoadMoreItem onClick={onLoadMore} disabled={loading}>
              <StyledExpandMoreIcon rightGutter={1} size="header" />
              <StyledTypography variant="body2">Load More</StyledTypography>
            </LoadMoreItem>
          )}
        </ScrollableContainer>
        <LastMenuItem onClick={handleApplyClick}>
          <StyledTypography color="primary" variant="body2">
            Apply
          </StyledTypography>
        </LastMenuItem>
      </StyledDropdownList>
    </CustomMenu>
  );
};

const StyledDropdownList = styled(DropdownList)`
  li {
    padding-left: 5px;
    span.MuiButtonBase-root {
      padding: 4px 10px;
    }
  }
`;

export default EmployeeFilter;
